import { KzIconGlobe } from '@kaizenplatform/kaizen-icon-elements';
import { createIconElement } from './createIconElement';

export const Globe = createIconElement(KzIconGlobe);
